import { z } from 'zod';

import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants/pagination';

import { zodAddressSchema } from '@vestigas/data';

import { toSnakeCase } from '@vestigas/utils';

import { SITE_TYPES } from '../constants';

import { SITES_ORDER_BY } from './constants';

/**
 * Zod schema for sites query parameters with defaults
 */
export const zodSitesQueryParamsSchema = z.object({
  filterActive: z.boolean().optional(),
  filterCompany: z.uuid().optional(),
  filterNotParentOu: z.uuid().optional(),
  filterParentOu: z.uuid().optional(),
  filterSiteType: z
    .preprocess((value) => toSnakeCase(String(value)), z.enum(SITE_TYPES))
    .optional(),
  limit: z.number().int().positive().prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().nonnegative().prefault(0),
  orderBy: z
    .preprocess((value) => toSnakeCase(String(value)), z.enum(SITES_ORDER_BY))
    .prefault('name'),
  returnAccountingReferences: z.boolean().prefault(true),
  returnTotalCount: z.boolean().prefault(true),
  searchString: z.string().trim().optional(),
  sort: z
    .preprocess(
      (value) => String(value).toUpperCase(),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .prefault('ASC'),
});

/**
 * Zod schema for a single site list item
 */
export const zodSiteListItemSchema = z.object({
  accountingReferences: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
    }),
  ),
  address: zodAddressSchema.optional(),
  companyId: z.uuid(),
  companyName: z.string(),
  coords: z
    .object({
      lat: z.number(),
      long: z.number(),
    })
    .optional(),
  createdOn: z.string(), // TODO: should be z.iso.datetime(), but we're not getting ISO 8601 dates
  end: z.string().nullable(), // TODO: should be z.iso.datetime().nullable(), but we're not getting ISO 8601 dates
  id: z.uuid(),
  isActive: z.boolean(),
  isSynced: z.boolean(),
  modifiedOn: z.string(), // TODO: should be z.iso.datetime(), but we're not getting ISO 8601 dates
  name: z.string(),
  start: z.string().nullable(), // TODO: should be z.iso.datetime().nullable(), but we're not getting ISO 8601 dates
  syncKey: z.string().nullish(),
  type: z.enum(SITE_TYPES),
});

/**
 * Zod schema for the sites list response from the API
 */
export const zodSitesResponseSchema = z.object({
  data: z.array(zodSiteListItemSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number(),
  totalCount: z.number(),
});
